import { Layout } from "@introist/react-foundation/v2";
import { TextInput } from "../../../components/atoms";
import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";

export const GenericPersonioFields = ({ values, onChange }: ConnectFormProps) => {
  return (
    <>
      <TextInput label="Name" value={values?.name} onChange={name => onChange({ name })} />
      <TextInput
        // @ts-expect-error
        value={values?.credentials?.clientId}
        label="Client ID"
        onChange={clientId => {
          onChange({
            credentials: {
              // @ts-expect-error
              clientSecret: values?.credentials?.clientSecret,
              clientId
            }
          });
        }}
      />
      <TextInput
        // @ts-expect-error
        value={values?.credentials?.clientSecret}
        label="Client secret"
        onChange={clientSecret =>
          onChange({
            credentials: {
              // @ts-expect-error
              clientId: values?.credentials?.clientId,
              clientSecret
            }
          })
        }
      />
    </>
  );
};

export const PersonioConnectForm = ({ values, onChange }: ConnectFormProps) => {
  return (
    <Layout.Group vertical gap="xLarge">
      <GenericPersonioFields values={values} onChange={onChange} />
    </Layout.Group>
  );
};

export const PersonioReportConnectForm = ({ values, onChange }: ConnectFormProps) => {
  return (
    <Layout.Group vertical gap="xLarge">
      <GenericPersonioFields values={values} onChange={onChange} />
      <TextInput
        label="Report ID"
        // @ts-expect-error
        value={values?.credentials?.reportId}
        onChange={reportId =>
          onChange({
            credentials: {
              // @ts-expect-error
              clientId: values?.credentials?.clientId, // @ts-expect-error
              clientSecret: values?.credentials?.clientSecret,
              reportId
            }
          })
        }
      />
    </Layout.Group>
  );
};
